/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as utils from '@/utils';
export default tsx.component({
    name: 'password-suggestions',
    functional: true,
    props: {
        error: p.ofType().required,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        const { error } = ctx.props;
        const feedback = error.feedback;
        const suggestions = feedback.suggestions;
        return (<div class={['password-suggestions', 'text-left', ctx.data.class, ctx.data.staticClass]}>
                <p>{feedback.warning}</p>

                {utils.ifOrEmpty(suggestions.length > 0, () => [
                <b>Suggestions</b>,
                <ul class="mb-0 pl-3">
                        {suggestions.map(suggestion => (<li>{suggestion}</li>))}
                    </ul>,
            ])}
            </div>);
    },
});
